import sample_1 from './climaSKurz.jpg';

export const climaSKurzImpressions = {
    sample_1,
};
